const __WEBPACK_NAMESPACE_OBJECT__ = flarum.core.compat['extensions/afrux-forum-widgets-core/common/extend/Widgets'];